import { Button } from '@components/common/button';
import AlertWrapper from './AlertWrapper';
import AlertTitle from './AlertTitle';
import AlertContent from './AlertContent';
import { DarkDimmed } from './Dimmed';

export type AlertPropsType = {
  title?: string;
  content: string;
  submitLabel?: string;
  onClickSubmit?: Function;
  onClose: Function;
};

export default function Alert({
  title,
  content,
  submitLabel,
  onClickSubmit,
  onClose,
}: AlertPropsType): React.ReactElement {
  const handleClickSubmit = () => {
    onClickSubmit && onClickSubmit();
    onClose();
  };

  return (
    <>
      <AlertWrapper>
        {title && <AlertTitle>{title}</AlertTitle>}
        <AlertContent>{content}</AlertContent>
        <div className="flex items-center justify-between w-full mt-[24px]">
          <div className="ml-[16px] flex-1">
            <Button
              fullWidth
              shape="pill"
              size="medium"
              color="primary"
              onClick={handleClickSubmit}
            >
              {submitLabel || '확인'}
            </Button>
          </div>
        </div>
      </AlertWrapper>
      <DarkDimmed />
    </>
  );
}
